module.exports = __webpack_public_path__ + "img/icon4s.896993fa.png";